import React from "react";

function Footer() {
  return (
    <>
      <div className="container">
        <hr className="custom-divider my-4" />
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4">
          <div className="col-md-4 d-flex align-items-center">
            <span className="mb-3 text-white mb-md-0 poppins-regular">
              © 2026 Guardian Protocol. All rights reserved.
            </span>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;
